import React from 'react';
import Text from 'antd/es/typography/Text';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { useUsersQuantity } from '@/modules/dashboard/hooks/useUsersQuantity';
import PropTypes from 'prop-types';

const UserQuantity = ({ range }) => {
  const { data: usersQuantity } = useUsersQuantity(range);
  const { t } = useTranslation('common');
  
  // Calculate total clients
  const totalClients = (usersQuantity || [])?.reduce(
    (sum, item) => sum + (item.count || 0),
    0,
  );
  
  return (
    <Card title={'Total de clientes'} bodyStyle={{ padding: '10px 24px' }}>
      <div>
        <Text strong style={{ fontSize: '30px' }}>{totalClients || 0}</Text>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {usersQuantity
          ?.sort((a, b) => a.count - b.count)
          ?.map((item) => (
            <div key={item.clientType} style={{ marginBottom: 2 }}>
              <Text strong>{item.count}</Text>
              <Text style={{ marginLeft: 8 }}>{t(`userType.${item.clientType}`)}</Text>
            </div>
          ))}
      </div>
    </Card>
  );
};

UserQuantity.propTypes = {
  range: PropTypes.object.isRequired,
};

export default UserQuantity;

